export default __webpack_public_path__ + "static/media/shield.09656b18.svg";